import React, { FC } from 'react';
import clsx from 'clsx';
import { CircularProgress, CircularProgressProps } from '@mui/material';
import styles from './Spinner.module.scss';

export enum Colors {
  DarkBlue = '#077DDF',
  Blue = '#1e95f8',
  LightBlue = '#e8f4ff',
  White = '#fff',
}

interface ISpinnerProps extends CircularProgressProps {
  background?: 'light' | 'dark';
  rootClassName?: string;
  isCompleted?: boolean;
}

const Spinner: FC<ISpinnerProps> = ({ background, className, rootClassName, size, thickness, color, isCompleted, ...props }) => {
  const getSpinnerBackgroundColor = (): Colors => {
    switch (background) {
      case 'light':
        return Colors.LightBlue;
      case 'dark':
        return Colors.DarkBlue;
      default:
        return Colors.White;
    }
  };

  const getSpinnerColor = (): Colors => color === 'secondary' ? Colors.White : Colors.Blue;

  return (
    <div className={clsx(styles.root, rootClassName)}>
      <CircularProgress
        variant="determinate"
        size={size ?? 36}
        thickness={thickness ?? 5}
        {...props}
        value={100}
        style={{ color: getSpinnerBackgroundColor() }}
      />
      <CircularProgress
        variant={isCompleted ? 'determinate' : 'indeterminate'}
        className={clsx(styles.topSpinner, className)}
        classes={{
          circle: styles.circle,
        }}
        value={isCompleted ? 100 : undefined}
        size={size ?? 36}
        thickness={thickness ?? 5}
        style={{ color: getSpinnerColor() }}
        {...props}
      />
    </div>
  );
};

export default Spinner;
